import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, ModalController, Events } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { Store } from "@ngrx/store";
import { SplashScreen } from "@ionic-native/splash-screen";
import { ContractsService } from "./app.contract.service";
import { Http, Response } from "@angular/http";

import { AppState } from "./app.reducer";
import { HomePage } from "../pages/home/home";
import { IdolsPage } from "../pages/idols/idols";
import { IdolsListPage } from "../pages/idols-list/idols-list";
import { LoginPage } from "../pages/login/login";
//import { SignupEmailPage } from '../pages/signup-email/signup-email';
import { LoginEmailPage } from "../pages/login-email/login-email";
import { RankingPage } from "../pages/ranking/ranking";
//import { ReceiveautographsPage } from '../pages/receiveautographs/receiveautographs';
import { SettingsPage } from "../pages/settings/settings";
import { User, Wallet } from "./app.models";
import { UserFetchAction } from "./app.actions";
import { UserprofilePage } from "../pages/userprofile/userprofile";
import { WalletPage } from "../pages/wallet/wallet";
import { SplashPage } from "../pages/splash/splash";
import { LegalPage } from "../pages/legal/legal";

import { AuthService } from "../services/auth.service";

import { WalletService } from "../services/wallet.service";
import { ConfigService } from "../services/config.service";
import { TranslateService } from "@ngx-translate/core";
import { StartPage } from "../pages/start/start";
import * as firebase from "firebase";
import { NodeService } from "../services/node.service";
import { AlertController } from "ionic-angular";

import { GoogleAnalytics } from "@ionic-native/google-analytics";

@Component({
  templateUrl: "app.html",
})
export class AppComponent {
  @ViewChild(Nav)
  nav: Nav;
  rootPage: any;
  desktop: boolean;
  public pages: Array<{ title: string; component: any; text: string }>;
  //public rootPage = LoginPage;
  public user$: User;
  public userprofilePage = UserprofilePage;
  public wallet$: Wallet;
  public walletPage = WalletPage;
  bitcoinValue: number;
  dollarAmount: number;
  idioms: any[] = [];
  watacoins: string;
  ios: boolean;
  tokens$: any[] = [];
  btn_color: string = "#ffff";

  constructor(
    private contractService: ContractsService,
    public platform: Platform,
    public statusBar: StatusBar,
    public store: Store<AppState>,
    public splashScreen: SplashScreen,
    private walletService: WalletService,
    private configService: ConfigService,
    private http: Http,
    private translateService: TranslateService,
    public modalCtrl: ModalController,
    private nodeService: NodeService,
    private alertCtrl: AlertController,
    private authService: AuthService,
    public events: Events,
    private ga: GoogleAnalytics
  ) {
    this.initializeApp();
    this.initAuth();
    if (this.platform.is("core")) {
      this.desktop = true;
    } else {
      this.desktop = false;
    }

    if (this.platform.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }

    this.ios = false;

    this.pages = [
      { title: "HOME_TITLE", text: "mis_watacards", component: HomePage },
      { title: "LISTA_FANS", text: "fans", component: RankingPage },
      { title: "Legal", text: "legal", component: LegalPage },
      { title: "AJUSTES", text: "ajustes", component: SettingsPage },
    ];

    this.idioms = [
      {
        value: "es",
        label: "Español",
      },
      {
        value: "en",
        label: "English",
      },
    ];
    this.authService.updateUserPhoto.subscribe((urlPhoto: string) => {
      this.user$.photoURL = urlPhoto;
    });
    /*
    this.events.subscribe("tokens", (tokens$: any) => {
      this.tokens$ = tokens$;
      if (this.tokens$.length > 0) {
        this.btn_color = "#fff";
      } else {
        this.btn_color = "#000";
      }
    });*/
    this.btn_color = "#fff";
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if ((<any>window).cordova) {
        // Okay, so the platform is ready and our plugins are available.
        // Here you can do any higher level native things you might need.
        this.statusBar.styleBlackOpaque();
        this.statusBar.backgroundColorByHexString("#0d2839");

        setTimeout(() => {
          this.splashScreen.hide();
        }, 3500);

        this.ga
          .startTrackerWithId("UA-154232445-1")
          .then(() => {})
          .catch((e) => alert("Error starting GoogleAnalytics == " + e));
      }
    });
  }

  openPage(page) {
    // Returns if try to open the same page
    if (this.nav.getActive().instance instanceof page.component) return;
    // Push new page into navigation
    this.nav.push(page.component);
  }

  async menuOpened() {
    //this.store.dispatch(new WalletFetchAction(this.user$));
    await this.getWalletWatacoins();
  }

  checkAppLastVersion() {
    const alert = this.alertCtrl.create({
      enableBackdropDismiss: false,
      subTitle: this.translateService.instant("idols_list.title_version"),
      buttons: [
        {
          text: this.translateService.instant("idols_list.update"),
          handler: () => {
            console.log("Update App");
            window.open(
              "https://play.google.com/store/apps/details?id=com.watafan.app",
              "_system"
            );
          },
        },
      ],
    });
    alert.present();
  }

  initAuth() {
    console.log("initAuth");
    this.authService.afAuth.authState.subscribe(
      (response) => {
        if (response) {
          this.configService.fetchGasProdConfigFan().then((res: any) => {
            if (res.version != res.AppVersion) {
              this.checkAppLastVersion();
            }
          });
          this.contractService.fetchSCAddresses().then(() => {
            this.authService
              .readUserData(response.uid)
              .then((snapshot) => {
                var user = snapshot.val();
                console.log("USER ", user);
                if (user) {
                  this.authService.setUser(
                    user.uid,
                    user.address,
                    user.displayName,
                    user.photoURL,
                    response.email
                  );
                  console.log("go home ", user, " ios ", this.ios);
                  if (
                    this.configService.getShowSlides() === "yes" &&
                    !this.ios
                  ) {
                    console.log("entradndo en startPage");
                    this.rootPage = StartPage;
                  } else {
                    console.log("entradndo en IdolsListPage");
                    this.rootPage = IdolsListPage;
                  }

                  this.user$ = user;

                  this.getWalletWatacoins();
                } else {
                  this.initUser(response);
                }
              })
              .catch((err) => {
                console.log("Error login", err);
              });
          });
        } else {
          this.rootPage = LoginEmailPage;
        }
      },
      () => {
        this.rootPage = LoginEmailPage;
      }
    );
  }

  initUser(response) {
    this.authService.readIdolData(response.uid).then((snapshot) => {
      var idol = snapshot.val();

      var address = this.walletService.getAddress();
      var acceptDataProtection = true;
      var urlPhoto = null;

      this.authService.writeUserData(
        response.uid,
        idol.name,
        acceptDataProtection,
        address,
        urlPhoto
      );
      this.authService.setUser(
        response.uid,
        address,
        idol.name,
        urlPhoto,
        response.email
      );

      console.log("data user login ", response);
      var user = this.authService.getUser();

      if (this.configService.getShowSlides() === "yes" && !this.ios) {
        console.log("entradndo en startPage");
        this.rootPage = StartPage;
      } else {
        console.log("entradndo en IdolsListPage");
        this.rootPage = IdolsListPage;
      }

      this.user$ = user;

      this.user$.photoURL = null;

      this.getWalletWatacoins();
    });
  }

  getBitcoinValue() {
    this.http
      .get("https://api.coinbase.com/v2/prices/spot?currency=USD")
      .subscribe((res: Response) => {
        if (res) {
          if (this.wallet$) {
            this.bitcoinValue = parseFloat(res.json().data.amount);
            this.dollarAmount = this.bitcoinValue * this.wallet$.ethers;
          }
        }
      });
  }

  choose(lang) {
    this.configService.setIdiom(lang);
    this.translateService.use(lang);
  }

  formatNumberDeciaml(value: number, decimal: number): string {
    var formatValue;
    var idiom = this.configService.getIdiom();
    if (idiom == "es")
      formatValue = new Intl.NumberFormat("es-ES", {
        maximumFractionDigits: decimal,
      }).format(value);

    if (idiom == "en")
      formatValue = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: decimal,
      }).format(value);
    console.log("format value " + formatValue);
    return formatValue;
  }

  getWalletWatacoins() {
    this.nodeService
      .getBalanceWatacoins()
      .then((wallet) => {
        this.wallet$ = wallet;
        this.watacoins = this.formatNumberDeciaml(wallet.watacoins, 2);
        console.log("Watacoins market " + this.watacoins);
      })
      .catch((err) => {
        console.log("err");
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts